import AdminApplicationCategoriesPage from "./pages/AdminApplicationCategoriesPage";
import AdminOrRefereeApplicationDetailsPage from "./pages/AdminOrRefereeApplicationDetailsPage";
import ApplicationDetailsPage from "./pages/ApplicationDetailsPage";
import ApplicationListPage from "./pages/ApplicationListPage";
import MyRefereeRequestsPage from "./pages/MyRefereeRequestsPage";
import ReferralsPage from "./pages/ReferralsPage";
import MyUpgradeRefereeRequestsPage from "../upgrade-application/pages/MyUpgradeRefereeRequestsPage";
import ProbationerApplicationWizard from "./pages/ProbationerApplicationWizard";
import AdminApplicationsByCategoryPage from "./pages/AdminApplicationsByCategoryPage";
import NecProbationerApplicationList from "./pages/NecProbationerApplicationList";
import NecProbationerApplicationDietCategoriesPage from "./pages/NecProbationerApplicationDietCategoriesPage";
import NecProbationerApplicationDietCategoryPage from "./pages/NecProbationerApplicationDietCategoryPage";
import AdminProbationerApplicationList from "./pages/AdminProbationerApplicationList";
import AdminProbationerApplicationDietCategoriesPage from "./pages/AdminProbationerApplicationDietCategoriesPage";
import AdminProbationerApplicationDietCategoryPage from "./pages/AdminProbationerApplicationDietCategoryPage";
import AdminProbationerReviewAssignmentPage from "./pages/AdminProbationerReviewAssignmentPage";
import AdminProbationerReviewAssignmentCategoriesPage from "./pages/AdminProbationerReviewAssignmentCategoriesPage";
import AdminProbationerMemberNumbersPage from "./pages/AdminProbationerMemberNumbersPage";
import AdminProbationerApplicationReviewPage from "./pages/AdminProbationerApplicationReviewPage";
import AdminApplicationAnalysisPage from "./pages/AdminApplicationAnalysisPage";
// examples

export const probationerRoutes = [
  {
    path: "/probationer-applications/new",
    element: <ProbationerApplicationWizard />,
    // "member" is included so a member upgrading to Fellow can update their
    // details through the same 8-step form.
    roles: ["probationer", "student", "firm", "technician", "member"],
  },

  {
    path: "/probationer-applications",
    element: <ApplicationListPage />,

    roles: [
      "member",
      "probationer",
      "executive",
      "chairman",
      "student",
      "technician",

      "fellow",
    ],
  },

  {
    // Standalone analysis across every application, scoped down by diet and
    // category on the page itself. Declared BEFORE the catch-all
    // /probationer-applications/:id so "analysis" is not read as an id.
    path: "/probationer-applications/analysis",
    element: <AdminApplicationAnalysisPage />,
    // Permission alone — see the note on /databank/analysis.
    perms: ["application.analysis.access"],
  },

  {
    path: "/probationer-applications/:id",
    element: <ApplicationDetailsPage />,
    roles: [
      "member",
      "probationer",
      "executive",
      "chairman",
      "student",
      "technician",

      "fellow",
      "admin",
      "assessor",
    ],
  },

  {
    path: "/probationer-applications/categories",
    element: <AdminApplicationCategoriesPage />,
    roles: ["admin"],
  },

  // ── Entry-application management ──────────────────────────────────────────
  // Gated on the privilege, not on holding the admin role, so an executive
  // office granted application_diet.access (the president) reaches the same
  // screens. Deciding an application stays separately gated on
  // application_diet.approve / .reject, server-side as well as here.
  {
    path: "/probationer-applications/admin",
    element: <AdminProbationerApplicationList />,
    perms: ["application_diet.access"],
  },
  {
    path: "/probationer-applications/nec/submissions",
    element: <NecProbationerApplicationList />,
    roles: [
      "admin",
      "member",
      "assessor",
      "executive",
      "chairman",
      "secretary",
    ],
  },

  {
    path: "/probationer-applications/nec/submissions/diets/:dietId/categories",
    element: <NecProbationerApplicationDietCategoriesPage />,
    roles: [
      "admin",
      "member",
      "assessor",
      "executive",
      "chairman",
      "secretary",
    ],
  },
  {
    path: "/probationer-applications/admin/submissions/diets/:dietId/categories",
    element: <AdminProbationerApplicationDietCategoriesPage />,
    perms: ["application_diet.access"],
  },
  {
    // Which category's assignment to work. Declared before the bare
    // /assignments route is irrelevant here (the paths differ at the last
    // segment), but kept adjacent to it so the pair reads together.
    path: "/probationer-applications/admin/submissions/diets/:dietId/assignments/categories",
    element: <AdminProbationerReviewAssignmentCategoriesPage />,
    perms: ["application_diet.access"],
  },
  {
    // One category's assignment queue — the screen the chooser above opens,
    // and the one the module links to from inside a category.
    path: "/probationer-applications/admin/submissions/diets/:dietId/assignments/category/:categoryId",
    element: <AdminProbationerReviewAssignmentPage />,
    perms: ["application_diet.access"],
  },
  {
    // Manual review assignment for a WHOLE diet — the counterpart of the
    // upgrade review cycle screen. Still reachable: the panel's load across
    // every category is a question about the diet, not a category.
    path: "/probationer-applications/admin/submissions/diets/:dietId/assignments",
    element: <AdminProbationerReviewAssignmentPage />,
    perms: ["application_diet.access"],
  },
  {
    // Entry numbers (S/P/T) for a diet's approved applicants, optionally
    // narrowed to one category. Gated on the issuing privilege rather than
    // section access — the page itself stamps the register.
    path: "/probationer-applications/admin/submissions/diets/:dietId/member-numbers/category/:categoryId",
    element: <AdminProbationerMemberNumbersPage />,
    perms: ["probationer_applications.member_number.issue"],
  },
  {
    path: "/probationer-applications/admin/submissions/diets/:dietId/member-numbers",
    element: <AdminProbationerMemberNumbersPage />,
    perms: ["probationer_applications.member_number.issue"],
  },
  {
    // Admin review of one entry application — the counterpart of
    // /admin/upgrade-applications/:id. Declared before the catch-all
    // /probationer-applications/:id so "admin" is not read as an id.
    path: "/probationer-applications/admin/:id",
    element: <AdminProbationerApplicationReviewPage />,
    perms: ["application_diet.access"],
  },

  {
    path: "/probationer-applications/nec/submissions/diets/:dietId/category/:categoryId",
    element: <NecProbationerApplicationDietCategoryPage />,
    roles: [
      "admin",

      "member",
      "assessor",
      "executive",
      "chairman",
      "secretary",
    ],
  },

  {
    // Was open to every member/assessor/executive role — this is the admin
    // review queue for a category, so it now sits behind the same privilege as
    // the rest of the section. The NEC route above keeps the wider audience.
    path: "/probationer-applications/admin/submissions/diets/:dietId/category/:categoryId",
    element: <AdminProbationerApplicationDietCategoryPage />,
    perms: ["application_diet.access"],
  },
  {
    path: "/probationer-applications/category/:categoryId",
    element: <AdminApplicationsByCategoryPage />,
    roles: ["admin"],
  },
  {
    path: "/admin-probationer-applications/:id",
    element: <AdminOrRefereeApplicationDetailsPage />,
    roles: [
      "member",
      "admin",
      "executive",
      "assessor",
      "chairman",
      "secretary",
      "chapter_chairman",
      "chapter_secretary",
      "past president",
    ],
  },
  {
    path: "/referrals",
    element: <ReferralsPage />,
    roles: [
      "member",
      "executive",
      "assessor",
      "chairman",
      "fellow",
      "secretary",
      "past president",
    ],
  },
  {
    path: "/my-referee-request",
    element: <MyRefereeRequestsPage />,
    roles: [
      "member",

      "executive",
      "assessor",
      "chairman",
      "fellow",
      "secretary",
      "past president",
    ],
  },
  {
    path: "/my-upgrade-referee-request",
    element: <MyUpgradeRefereeRequestsPage />,
    roles: [
      "member",
      "executive",
      "assessor",
      "chairman",
      "fellow",
      "secretary",
      "past president",
    ],
  },
  {
    // Referee's OWN detail page (not the admin URL). Renders the same adaptive
    // component, which shows the referee view + accept/reject for the logged-in
    // member. :id is the probationer application id.
    path: "/my-referee-request/:id",
    element: <AdminOrRefereeApplicationDetailsPage />,
    roles: [
      "member",
      "executive",
      "assessor",
      "chairman",
      "fellow",
      "secretary",
      "past president",
    ],
  },
];
